<div class="modal-header robotomono-font">
  <h3 class="modal-title text-center sarabun-font" style="margin-left: auto; margin-right: auto;">
    <strong *ngIf="currentStage === PointCollectStage.PROVIDE_MOBILE_NO">
      <img src="assets/img/points/point-header-1.png" alt="" class="img-fluid modal-header-logo">
    </strong>
    <strong *ngIf="currentStage === PointCollectStage.PROVIDE_INFO">
      <img src="assets/img/points/point-header-2.1.png" alt="" class="img-fluid modal-header-logo">
    </strong>
    <strong *ngIf="currentStage === PointCollectStage.SHOW_POINTS && !claimingPoints">
      <img src="assets/img/points/point-header-3.png" alt="" class="img-fluid modal-header-logo">
    </strong>
    <strong *ngIf="currentStage === PointCollectStage.SHOW_POINTS && claimingPoints">
      <img src="assets/img/points/point-header-4.png" alt="" class="img-fluid modal-header-logo">
    </strong>
  </h3>
</div>
<div class="modal-body robotomono-font p-3" style="background-color: #ffffff">
  <div class="fixed-height" *ngIf="currentStage === PointCollectStage.PROVIDE_MOBILE_NO">
    <div class="form-group phone-input-wrapper">
      <input type="text" class="form-control text-center phone-input sarabun-font"
        [ngClass]="typedMobileNo ? 'regular-control' : 'focus-control'" id="mobileNo" placeholder="Phone number"
        [value]="maskedPhone" name="mobileNo" autocomplete="mobileNo" maxlength="10" readonly />
      <div class="first-layer mt-2">
        <div class="numpad-box">
          <div>
            <button class="btn btn-lg btn-light numpad-button numpad-button-1" (click)="addCharacter('1')">1</button>
            <button class="btn btn-lg btn-light numpad-button numpad-button-2" (click)="addCharacter('2')">2</button>
            <button class="btn btn-lg btn-light numpad-button numpad-button-3" (click)="addCharacter('3')">3</button>
          </div>
          <div>
            <button class="btn btn-lg btn-light numpad-button numpad-button-4" (click)="addCharacter('4')">4</button>
            <button class="btn btn-lg btn-light numpad-button numpad-button-5" (click)="addCharacter('5')">5</button>
            <button class="btn btn-lg btn-light numpad-button numpad-button-6" (click)="addCharacter('6')">6</button>
          </div>
          <div>
            <button class="btn btn-lg btn-light numpad-button numpad-button-7" (click)="addCharacter('7')">7</button>
            <button class="btn btn-lg btn-light numpad-button numpad-button-8" (click)="addCharacter('8')">8</button>
            <button class="btn btn-lg btn-light numpad-button numpad-button-9" (click)="addCharacter('9')">9</button>
          </div>
          <div>
            <button class="btn btn-lg btn-light numpad-button numpad-button-clear small-text text-center"
              (click)="resetCharacter()"><strong>CLEAR</strong></button>
            <button class="btn btn-lg btn-light numpad-button numpad-button-0" (click)="addCharacter('0')">0</button>
            <button class="btn btn-lg btn-light numpad-button numpad-button-delete small-text text-center"
              (click)="delCharacter()"><strong>DELETE</strong></button>
          </div>
        </div>
      </div>
      <div class="mt-3">
        <div class="row">
          <div class="col-1">
            <div class="form-check sarabun-font consent-checkbox">
              <input class="form-check-input" type="checkbox" id="consentCheckbox" [(ngModel)]="consentGiven">
            </div>
          </div>
          <div class="col-11">
            <label class="form-check-label sarabun-font text-start">
              I agree to the <span class="consent-link" (click)="openTermModal()"><strong>Terms & Privacy
                  Policy</strong></span><br>
              ฉันยอมรับ <span class="consent-link"
                (click)="openTermModal()"><strong>ข้อกำหนดและนโยบายความเป็นส่วนตัว</strong></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="fixed-height d-flex flex-column justify-content-center"
    *ngIf="currentStage === PointCollectStage.PROVIDE_INFO">
    <div class="text-center">
      <label class="d-block mb-2">
        <img src="assets/img/points/point-header-2.2.png" alt="" class="img-fluid modal-header-sublogo">
      </label>
      <div class="d-flex justify-content-center align-items-center gap-2 date-picker-cols">
        <div class="row w-100">
          <div class="col-sm-12 col-md-3 mt-3">
            <div class="">
              <ng-select class="custom-small date-select" [items]="days" bindLabel="" [searchable]="false"
                [clearable]="false" [(ngModel)]="selectedDay" placeholder="Day">
              </ng-select>
            </div>
          </div>
          <div class="col-sm-12 col-md-5 mt-3">
            <div class="">
              <ng-select class="custom-small date-select" [items]="months" bindLabel="name" bindValue="id"
                [searchable]="false" [clearable]="false" [(ngModel)]="selectedMonth" (change)="onMonthOrYearChange()"
                placeholder="Month">
              </ng-select>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 mt-3">
            <div class="">
              <ng-select class="custom-small date-select" [items]="years" [searchable]="false" [clearable]="false"
                [(ngModel)]="selectedYear" (change)="onMonthOrYearChange()" placeholder="Year">
              </ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center mt-5">
      <label class="d-block mb-2">
        <img src="assets/img/points/point-header-2.3.png" alt="" class="img-fluid modal-header-sublogo">
      </label>
      <div class="d-flex justify-content-center align-items-center gap-2">
        <div class="row w-100">
          <div class="col-sm-12 col-md-12 mt-3">
            <div class="">
              <ng-select class="custom-small gender-select" [items]="genders" bindLabel="name" bindValue="id"
                [searchable]="false" [clearable]="false" [(ngModel)]="selectedGender" placeholder="Gender">
              </ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="fixed-height" *ngIf="currentStage === PointCollectStage.SHOW_POINTS">
    <div class="text-center h-100" *ngIf="!claimingPoints">
      <div class="gap-2 h-100 text-center d-flex flex-column justify-content-center align-items-center">
        <div class="sculpture-card d-flex flex-column justify-content-center align-items-center">
          <div class="row-100 w-100">
            <div class="sculpture-card-logo d-flex justify-content-start">
              <img class="img-fluid" src="assets/img/points/card-logo.png" alt="">
            </div>
          </div>
          <div class="row-10 w-100">
            <div
              class="sculpture-card-item col-10-land-2 col-10-vert-2 d-flex justify-content-center sculpture-card-bg-{{ i + 1 }}"
              *ngFor="let point of pointCollected; let i = index">
              <div *ngIf="(i + 1) % 10 !== 0">
                <div *ngIf="!point.claimed">
                  <div class="point-blank">
                  </div>
                </div>
                <div *ngIf="point.claimed">
                  <div class="point-blank-claimed">
                    <img class="img-fluid" src="assets/img/points/card-star.png" alt="">
                  </div>
                </div>
              </div>
              <div *ngIf="(i + 1) % 10 === 0">
                <div *ngIf="!point.claimed">
                  <div class="point-blank">
                  </div>
                </div>
                <div *ngIf="point.claimed">
                  <div class="point-blank-claimed">
                    <img class="img-fluid" src="assets/img/points/card-star.png" alt="">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center h-100" *ngIf="claimingPoints">
      <div class="gap-2 h-100 text-center d-flex flex-column justify-content-center align-items-center">
        <div class="sculpture-card-claim d-flex flex-column justify-content-center align-items-center mt-3">
          <div class="row-100 w-100">
            <div class="sculpture-card-logo d-flex justify-content-center">
              <img class="img-fluid" src="assets/img/points/card-claim-logo.png" alt="">
            </div>
          </div>
          <div class="row-10 w-100 mt-3">
            <div class="col-10-10">
              <div class="sculpture-claim-code">
                {{ promoCodeFromRedemption}}
              </div>
            </div>
          </div>
          <div class="row-10 w-100 mt-3">
            <div class="col-10-10">
              <div class="sculpture-card-tag d-flex justify-content-center w-100">
                <img class="img-fluid" src="assets/img/points/card-claim-tag.png" alt="">
              </div>
            </div>
          </div>
          <div class="row-10 w-100 mt-3">
            <div class="col-10-10">
              <div class="sculpture-card-expire d-flex justify-content-between w-100">
                <span>Expire Date: {{ promoExpiryDateFromRedemption }}</span>
                <span>Expire Date: {{ promoExpiryDateFromRedemption }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="sculpture-card-claim-footer text-left mt-3">
          <small><strong>Terms of Use</strong></small>
          <ul>
            <li><small>Valid for one use per code</small></li>
            <li><small>Please enter the code before starting the photo session</small></li>
            <li><small>Cannot be used in conjunction with other promotions</small></li>
            <li><small>The code is valid for one year from the date received (no extensions allowed)</small></li>
            <li><small>Using this code does not affect point accumulation</small></li>
            <li><small>Valid at all Sculpture photobooth locations (except XXL Booth, Video Drawing Booth, and Gashapon Booth)</small></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div *ngIf="currentStage === PointCollectStage.PROVIDE_MOBILE_NO" class="w-100">
    <div class="d-flex align-items-center">
      <div>
        <button type="button" class="btn btn-lg btn-pill btn-skip p-0" (click)="skipConsent()"></button>
      </div>
      <div class="ml-auto">
        <button type="button" class="btn btn-lg btn-pill btn-next p-0" (click)="submitMobileNo()"
          [disabled]="!isMobileNoComplete() || !consentGiven">
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="currentStage === PointCollectStage.PROVIDE_INFO" class="w-100">
    <div class="d-flex align-items-center">
      <div>
        <!-- <button type="button" class="btn btn-lg btn-light btn-pill" (click)="backToMobile()">Back</button> -->
      </div>
      <div class="ml-auto">
        <button type="button" class="btn btn-lg btn-pill btn-next p-0" (click)="submitInfo()">
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="currentStage === PointCollectStage.SHOW_POINTS" class="w-100">
    <div class="d-flex align-items-center">
      <div class="ml-auto">
        <button type="button" class="btn btn-lg btn-pill btn-next p-0" (click)="submitFinal()">
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template #termModal let-modal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title sarabun-font"><strong>Terms and Condition / Privacy Policy</strong></h4>
  </div>
  <div class="modal-body sarabun-font" style="background-color: #ffffff;">
    <div>
      <h5 class="text-center"><strong>ข้อกำหนดและนโยบายความเป็นส่วนตัว (ฉบับย่อ)</strong></h5>
      <p>
        เพื่อเข้าร่วม <i>ระบบสะสมแต้ม Photobooth ณ Sculpture Bangkok</i> ร้านจะเก็บข้อมูลของท่าน ได้แก่
        <i>เบอร์โทรศัพท์,
          วันเดือนปีเกิด, และ เพศ</i> เพื่อใช้ในการลงทะเบียนสมาชิก สะสมแต้ม แลกรางวัล และปรับปรุงการให้บริการ
      </p>
      <p>
        ร้านจะไม่ขายหรือเปิดเผยข้อมูลแก่บุคคลภายนอก และท่านสามารถขอเข้าถึง แก้ไข ลบข้อมูล หรือถอนความยินยอมได้
        ผ่านช่องทางออนไลน์ต่อไปนี้
      </p>
      <ul>
        <li>Line OA: @sculpturebangkok</li>
        <li>Email: thisissculpturebangkok@gmail.com</li>
      </ul>
    </div>
    <hr>
    <div>
      <h5 class="text-center"><strong>Terms & Privacy Policy (Short Version)</strong></h5>
      <p>
        To participate in the <i>Photobooth Loyalty Program at Sculpture Bangkok</i>, we collect your personal data,
        including
        <i>phone number, date of birth, and gender</i>
      </p>
      <p>
        Your data is used for membership registration, point collection, reward redemption, and service improvement
        purposes only
      </p>
      <p>
        We do not sell or disclose your data to third parties, you may request access, correction, deletion, or
        withdrawal of consent
        through the following online channels
      </p>
      <ul>
        <li>Line OA: @sculpturebangkok</li>
        <li>Email: thisissculpturebangkok@gmail.com</li>
      </ul>
    </div>
  </div>
  <div class="modal-footer text-left">
    <button type="button" class="btn btn-light btn-lg btn-pill sarabun-font mr-auto" (click)="onDecline()">Not
      Accept</button>
    <button type="button" class="btn btn-dark btn-lg btn-pill sarabun-font" (click)="onAccept()">Accept</button>
  </div>
</ng-template>

<app-loading *ngIf="commonService.isLoading"></app-loading>